import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { ClarityModule } from '@clr/angular';
import { NgcCookieConsentConfig, NgcCookieConsentModule } from 'ngx-cookieconsent';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { AboutModule } from './about/about.module';
import { DocsModule } from './docs/docs.module';
import { ExamplesModule } from './examples/examples.module';
import { SyntenyBrowserModule } from './synteny-browser/synteny-browser.module';

import { environment } from "../environments/environment";

const cookieConfig: NgcCookieConsentConfig = {
  cookie: {
    domain: environment.cookieDomain // it is mandatory to set a domain, for cookies to work properly (see https://goo.gl/S2Hy2A)
  },
  position: 'bottom',
  palette: {
    popup: {
      background: '#E5E7EB'
    },
    button: {
      background: '#f1d600'
    }
  },
  theme: 'classic',
  type: 'opt-out',
  content: {
    message: `Welcome! Our website uses cookies exclusively for usage analytics and reporting metrics to our
    stakeholders and funding agencies about site usage. These cookies also help us understand how visitors
    interact with our site, enabling us to improve your browsing experience and the content we offer. We
    respect your privacy and ensure that all data collected is anonymized and used solely to guide our
    enhancements. Additionally, we do not use this data for marketing purposes nor do we share any user
    information with third parties.
    By clicking "Accept," you consent to our use of cookies for these purposes. For more detailed information
    on the cookies we use and how we handle your data, please review our`,
    dismiss: 'Allow cookies',
    deny: 'Decline',
    allow: 'Accept',
    link: 'Privacy Policy.',
    href: 'https://www.jax.org/privacy-policy',
    policy: 'Cookie Policy'
  }
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    AboutModule,
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    DocsModule,
    ExamplesModule,
    SyntenyBrowserModule,
    DeviceDetectorModule.forRoot(),
    ClarityModule,
    NgcCookieConsentModule.forRoot(cookieConfig)
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
